export default {
    //apiUrl: process.env.API_URL
    //apiUrl: "http://localhost:64093/"
    //apiUrl: "https://api.staging.ohiokan.org/"
    apiUrl: "https://api.phone.ohiokan.org/"
};
